import { AxiosRequestConfig } from "axios";
import {
	AiAnalysisApiResponse,
	ApiResponse,
	StockDetailsApiResponse,
	StockFilingsApiResponse,
	StockDailyCloseApiResponse,
	FinancialSummaryApiResponse,
	StockDataApiResponse,
	StockPriceChangeApiResponse,
	StockCompanyDetailsApiResponse,
} from "../models/api-response";
import { fetchAiAnalysis, fetchCompanyDetails, fetchStockData, fetchStockDetails, fetchStockFilings, fetchStockPriceChange, fetchStockSummary } from "./external-api.service";
import { AIAnalysis, FinancialSummary, Stock, StockCompanyDetails, StockDailyClosePrice, StockData, StockPriceChange, YearlyScore } from "src/models/stock-types";

const apiServerUrl = process.env.REACT_APP_API_SERVER_URL;

export const getTopFilings = async (
	accessToken: string
): Promise<ApiResponse<Stock[]>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/topFilings/9`,
		method: "GET",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
	};

	const { data, error } = (await fetchStockFilings({
		config,
	})) as StockFilingsApiResponse;
	return {
		data,
		error,
	};
};

export const getStockData = async (
	accessToken: string,
	amount: number,
	selectedFilter: string
): Promise<ApiResponse<StockData[]>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/stocks/getTopRanked/${amount}/${selectedFilter}`,
		method: "GET",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
	};

	const { data, error } = (await fetchStockData({
		config,
	})) as StockDataApiResponse;
	return {
		data,
		error,
	};
};

export const getStockCompanyDetails = async (
	accessToken: string,
	ticker: string,
): Promise<ApiResponse<StockCompanyDetails>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/companyDetails/${ticker}`,
		method: "GET",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
	};

	console.log("Fetching company details for ticker:", ticker);

	const { data, error } = (await fetchCompanyDetails({
		config,
	})) as StockCompanyDetailsApiResponse;

	return {
		data,
		error,
	};
};

export const getStockDetails = async (
	accessToken: string,
	ticker: string,
	yearRange: number
): Promise<ApiResponse<YearlyScore[]>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/stocks/getHistoricalData/${ticker}/${yearRange}`,
		method: "GET",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
	};

	const { data, error } = (await fetchStockDetails({
		config,
	})) as StockDetailsApiResponse;

	return {
		data,
		error,
	};
};

export const getStockSummary = async (
    accessToken: string,
    ticker: string
): Promise<ApiResponse<FinancialSummary>> => {
    const config: AxiosRequestConfig = {
        url: `${apiServerUrl}/api/analyzeStock/${ticker}`,
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = (await fetchStockSummary({
        config,
    })) as FinancialSummaryApiResponse;
	
    return {
        data,
        error,
    };
};

export const getStockPriceChange = async (
	accessToken: string,
	ticker: string,
): Promise<ApiResponse<StockPriceChange>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/marketData/priceChange/${ticker}`,
		method: "GET",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
	};

	const { data, error } = (await fetchStockPriceChange({
		config,
	})) as StockPriceChangeApiResponse;

	return {
		data,
		error,
	};
};

export const getAiAnalysis = async (
	accessToken: string,
	ticker: string,
	yearlyScores: number,
): Promise<ApiResponse<AIAnalysis>> => {
	const config: AxiosRequestConfig = {
		url: `${apiServerUrl}/api/semantic-kernel/stockEvaluation`,
		method: "POST",
		headers: {
			"content-type": "application/json",
			Authorization: `Bearer ${accessToken}`,
		},
		data: {
			ticker,
		},
	};

	const { data, error } = (await fetchAiAnalysis({
		config,
	})) as AiAnalysisApiResponse;

	return {
		data,
		error,
	};
};


// export const getStockDailyClosePrice = async (
// 	accessToken: string,
// 	ticker: string,
// ): Promise<ApiResponse<StockDailyClosePrice>> => {
// 	const config: AxiosRequestConfig = {
// 		url: `${apiServerUrl}/api/marketData/${ticker}/today`,
// 		method: "GET",
// 		headers: {
// 			"content-type": "application/json",
// 			Authorization: `Bearer ${accessToken}`,
// 		},
// 	};

// 	const { data, error } = (await fetchAiAnalysis({
// 		config,
// 	})) as StockDailyCloseApiResponse;

// 	return {
// 		data,
// 		error,
// 	};
// };
